import { handleScanKeyboard, handleScanSDK } from 'root/scan/ScanHandler';
import { ScanKeyboardDetectionFactory } from 'root/scan/ScanKeyboardDetection';

export const initScanCapture = () => {
  // Retail Manager will look for this function to handle scans
  window.handleScanSDK = handleScanSDK;
  // On Web, start observing keyboard input to detect barcode scans
  const ScanKeyboardDetection = ScanKeyboardDetectionFactory(handleScanKeyboard);
  ScanKeyboardDetection.start();
};
